import request from '../common/request.js';

//获取授权列表
export function GetWorkSQList(payload) {
    return request.post('/sys/GetWorkSQList', payload);
}

//新增授权
export function AddWorkSQ(payload) {
    return request.post('/sys/AddWorkSQ', payload);
}

//删除授权
export function DeleteWorkSQ(payload) {
    return request.post('/sys/DeleteWorkSQ', payload);
}

//更新授权
export function UpdateWorkSQ(payload) {
    return request.post('/sys/UpdateWorkSQ', payload);
}